/**
 * Geofencing - Calculo de distancia e taxa de entrega
 * Baseado em Piabeta/Mage, RJ
 */

const RESTAURANT_DEFAULT = { lat: -22.6128, lng: -43.1635 };

// Haversine formula
export function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function calculateDeliveryFee(distanceKm, baseFee = 5.0, perKm = 2.0) {
  if (distanceKm <= 2) return baseFee;
  return baseFee + (distanceKm - 2) * perKm;
}

// v7.70 — Removidos NEIGHBORHOODS (lista simulada) e getNeighborhoodDistance:
// legado da era de cadastro manual de bairros, sem nenhum consumidor após a
// migração para cálculo de frete estritamente por distância (Places API).

// Simulate delivery person moving from restaurant to customer
export function simulateDeliveryPath(customerLat, customerLng, steps = 20) {
  const path = [];
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    const jitterLat = (Math.random() - 0.5) * 0.001;
    const jitterLng = (Math.random() - 0.5) * 0.001;
    path.push({
      lat: RESTAURANT_DEFAULT.lat + (customerLat - RESTAURANT_DEFAULT.lat) * t + jitterLat,
      lng: RESTAURANT_DEFAULT.lng + (customerLng - RESTAURANT_DEFAULT.lng) * t + jitterLng,
      progress: Math.round(t * 100),
    });
  }
  return path;
}
